// Purpose: route guard for /admin/*. Redirects non-admins home and
// renders the outlet for ADMIN users. 428 step-up handling lives in the
// axios interceptor (api/client.ts), so this component does not need to
// know about the MFA dance — it only gates on role.

import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext.tsx';

export function RequireAdmin() {
  const { status, user } = useAuth();
  if (status === 'loading') {
    return <p className="p-6 text-fg-muted text-body-m">Loading…</p>;
  }
  if (status === 'unauthenticated' || !user) {
    return <Navigate to="/login" replace />;
  }
  if (user.role !== 'ADMIN') {
    return <Navigate to="/" replace />;
  }
  return <Outlet />;
}
